import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core/index.cjs";

const filial = (params = {}) => {
    return {
        id: params.id || "",
        codigo: params.codigo || "",
        descricao: params.descricao || "",
        cnpj: params.cnpj || "",
        cliente: params.cliente || "",
        fornecedor: params.fornecedor || "",
        faturamentoEntrega: params.faturamentoEntrega || "",
    };
};

const useFilialStore = defineStore("FilialStore", {
    state: () => ({
        filial: useLocalStorage("FilialStore", filial()),
    }),
    actions: {
        save(params) {
            this.filial = filial(params);
        },
        clear() {
            this.filial = filial();
        },
    },
});

export default useFilialStore;
